var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _path9, _g3, _g4, _path0, _path1, _path10, _path11, _g5, _path12, _g6, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g7, _path23, _path24, _path25, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.545,
    height: 74.545,
    viewBox: "0 0 74.545 74.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 34.776,
    height: 53.546,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 12.534,
    height: 8.881,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 3.142,
    height: 20.552,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 6.122,
    height: 5.429,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 6.765,
    height: 4.945,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M528.269,0c-.007,0,.057.55-.724,1.066-1.1.729-.375,1.75-.958,1.937s-.02,2.245,0,2.562c.042.646.229.208.313-.354s1.083-1.646.833-1.812.646-1.083.542-1.645.417-.667.1-1.437A2.6,2.6,0,0,1,528.269,0Z",
    transform: "translate(-526.323 -0.003)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.167,
    y1: 18.298,
    x2: -3.161,
    y2: 18.298,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8cc63f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 3.466,
    height: 1.113,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 2.148,
    height: 5.889,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 5.22,
    height: 2.13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 1.295,
    height: 0.376,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 0.919,
    height: 0.292,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 2.802,
    height: 0.987,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 3.082,
    height: 1.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 2.101,
    height: 3.043,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 1.764,
    height: 3.417,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 21.472,
    height: 5.373,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1683",
    "data-name": "Group 1683",
    transform: "translate(1173.103 -5403.567)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u05D0\\u05D5\\u05D5\\u05D8\\u05E8-1-01",
    cx: 37.273,
    cy: 37.273,
    r: 37.273,
    transform: "translate(-1173.103 5403.567)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1532",
    "data-name": "Group 1532",
    transform: "translate(-1149.958 5411.785)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M2.275,835.343s1.079-4.768,4.5-5.518,12.814-3.676,15.65-3.253,9.021,1.128,10.825,5.147c3.717,8.281-.526,13.563-.526,13.563L0,845.557Z",
    transform: "translate(0 -792.012)",
    fill: "#ff6947"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M230.654,733.311c-.34.215-.551,1.9,1.527,6.863s-10.718,7.43-11.439,4.518.359-5.973-1.535-8.573,11.447-2.808,11.447-2.808",
    transform: "translate(-209.876 -702.685)",
    fill: "#c69c6d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M27.793,268.524c-.209.209.084,1.169-.209,1.42a4.57,4.57,0,0,1-1.336.877,2.489,2.489,0,0,0,1,0s-1.211,1-1.253,1.671c0,0,.752-.459.752,0,0,0-.877,1-1.8.835a1.563,1.563,0,0,0,1.42.668l-.9.97,1.944,1.2,1-7.643Z",
    transform: "translate(-23.911 -257.31)",
    fill: "#534741"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M513.758,396.776c-.084-.084,3.091-4.469,5.387-1.253s-.334,6.557-4.093,4.636-1.295-3.383-1.295-3.383",
    transform: "translate(-491.541 -377.877)",
    fill: "#c69c6d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M12.514,416.769s-1.5-2.589-3.341-.793-.418,6.014,2.631,4.886.71-4.093.71-4.093",
    transform: "translate(-8.005 -397.996)",
    fill: "#c69c6d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M68.436,251.888s.645.406-.483,1.283a.834.834,0,0,0,.668,0s-.663,2.2-.185,2.832c0,0,2.44-5.046,2.44-5.213s-.668-6.265-.668-6.265l-1,.418Z",
    transform: "translate(-65.115 -234.313)",
    fill: "#534741"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480",
    transform: "translate(9.148 30.626)",
    opacity: 0.68,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M219.4,735.016a5.491,5.491,0,0,0-.353.508.76.76,0,0,0,.173.595c1.187,1.63,1.206,3.441,1.232,5.282,1.8,1.11,5.268,1.7,11.118-2.8-1.4-3.757-1.2-5.1-.9-5.29,0,0-9.3.145-11.267,1.705",
    transform: "translate(-219.036 -733.311)",
    fill: "#534741"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M63.2,213.037a6,6,0,0,0-4.862,5.273c-.219,2.1-.439,4.207-.541,4.472-.209.543-2.629,7.446-.71,11.193,1.754,3.425,4.093,3.842,4.508,3.98a4.54,4.54,0,0,1,1.478.884c.816.692,2.539,1.475,5.606.076a5.92,5.92,0,0,1,2.948-.517c2.2.184,5.142-.775,6.592-5.509,1.356-4.427,1.226-6.564.279-7.9a5.946,5.946,0,0,1-1.067-2.958l-.243-2.96a6,6,0,0,0-.633-2.23l-.895-1.757a6,6,0,0,0-6.445-3.173Z",
    transform: "translate(-53.995 -202.964)",
    fill: "#c69c6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(2.353 13.439)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M58.586,324.785a10.811,10.811,0,0,0,.274-3,5.986,5.986,0,0,0-.527,1.907c-.219,2.1-.439,4.207-.541,4.472-.209.543-2.629,7.446-.71,11.193a8.355,8.355,0,0,0,2.407,2.981c-3.079-3.691-2.262-10.84-.9-17.556",
    transform: "translate(-56.348 -321.789)",
    fill: "#fff"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M358.453,255.024s3.049,1.545,2.464,3.3a5.265,5.265,0,0,0,.793-1.629s.668,1.086,1.42,1.128c0,0-.334-.71,0-.752a1.841,1.841,0,0,1,.961,1.8s.71-.418.835-.877a7.162,7.162,0,0,0,.418,2.84,2.3,2.3,0,0,1-.877,2.548,1.09,1.09,0,0,0,1.253-1s-.5,2.3.251,2.965a4.018,4.018,0,0,1,.292-1.629s.71,1.462.5,2.088a6.653,6.653,0,0,0-.167-2.756c-.418-1.169,1.679-2.035,1.679-2.035l-2.849-5.983Z",
    transform: "translate(-343.483 -244.373)",
    fill: "#534741"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M537.225,286.63a2.673,2.673,0,0,0,1.805-.689c.835-.752,1.336.334,1.336.334s-.835-.334-.919.376a.588.588,0,0,0,.752.209,2.281,2.281,0,0,1-.919,1.754s2.088-.668,2.381.585c0,0-1.086-.167-1,.668a.976.976,0,0,1,.877.334.733.733,0,0,0,.835.209s-.477.208-.447.438-2.811.1-2.811.1Z",
    transform: "translate(-514.789 -273.745)",
    fill: "#534741"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486",
    transform: "translate(5.164 16.894)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M127.242,404.524s3.09,2,2.422,5.429a9.12,9.12,0,0,0-5.805-.292s-1.086-3.717,1.545-4.3Z",
    transform: "translate(-123.637 -404.524)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489",
    transform: "translate(12.85 17.086)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M311.882,409.252s5.1,1.754.961,4.8a6.594,6.594,0,0,0-4.552,0s-2.756-5.93,3.592-4.8",
    transform: "translate(-307.695 -409.11)",
    fill: "#534741"
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M229.582,269.507a2.056,2.056,0,0,0,.543,2.673c1.336.835,1.671-.125,1.8.961,0,0,.292-1.295-.626-1.629,0,0,.835.752,1.545.251,0,0-.626-1.044-.167-1.378,0,0,1,0,.835.919,0,0,.626.167.334-1.8s-4.26,0-4.26,0",
    transform: "translate(-219.728 -257.416)",
    fill: "#534741"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M101.21,246.173a2.056,2.056,0,0,0,1.518,2.266c1.554.265,1.5-.751,2.026.206,0,0-.222-1.309-1.2-1.268,0,0,1.058.378,1.525-.355,0,0-.976-.728-.678-1.211,0,0,.927-.381,1.122.532,0,0,.643-.084-.373-1.788s-3.94,1.619-3.94,1.619",
    transform: "translate(-96.948 -233.875)",
    fill: "#534741"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M171.21,222.173a2.056,2.056,0,0,0,1.518,2.266c1.554.265,1.5-.751,2.026.206,0,0-.222-1.309-1.2-1.269,0,0,1.058.378,1.525-.355,0,0-.976-.728-.678-1.211,0,0,.927-.381,1.122.532,0,0,.643-.084-.373-1.788s-3.94,1.619-3.94,1.619",
    transform: "translate(-164.025 -210.877)",
    fill: "#534741"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M309.06,223.3a2.475,2.475,0,0,1-1.413,2.964c-1.8.586-1.915-.633-2.377.6,0,0,.036-1.6,1.206-1.72,0,0-1.195.635-1.878-.158,0,0,1.036-1.037.6-1.561,0,0-1.171-.292-1.243.83,0,0-.78.013.133-2.195s4.975,1.241,4.975,1.241",
    transform: "translate(-290.96 -212.079)",
    fill: "#534741"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(21.981 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 6.273,
    height: 2.834,
    transform: "translate(-0.467 6.207) rotate(-88.636)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1531",
    "data-name": "Group 1531",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1530",
    "data-name": "Group 1530",
    clipPath: "url(#clip-path)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M398.06,239.3a2.475,2.475,0,0,1-1.413,2.964c-1.8.586-1.915-.633-2.377.6,0,0,.036-1.6,1.206-1.72,0,0-1.195.635-1.878-.158,0,0,1.036-1.037.6-1.561,0,0-1.171-.292-1.243.83,0,0-.78.013.133-2.195s4.975,1.241,4.975,1.241",
    transform: "translate(-376.243 -227.41)",
    fill: "#534741"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496",
    transform: "translate(9.583 24.767)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1494",
    "data-name": "Group 1494",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M229.453,593.024s.752,2.088,3.466.543c0,0-2.381.543-3.466-.543",
    transform: "translate(-229.453 -593.024)",
    fill: "#534741"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M197.926,592.787c1.07.758,3.477,1.832,6.949-.26l.017-.011a7.5,7.5,0,0,0,2.381-2.859.234.234,0,0,1,.21-.132h.227a.234.234,0,0,1,.232.262c-.075.607.015,2.28-.472,3.079-.811,1.331-1.837,3.547-5.938,3.334h-.017a4.838,4.838,0,0,1-3.94-3.132.233.233,0,0,1,.351-.28",
    transform: "translate(-189.305 -564.904)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M369.953,403.687a11.921,11.921,0,0,1,1.253-.209c.5-.042,2.589.585,1.754,1.169s-1.169-.919-3.007-.961",
    transform: "translate(-354.502 -386.626)",
    fill: "#534741"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M79.914,73.453s-1.253-7.643.71-8.687a20.876,20.876,0,0,1,19.963,1.462c.543.459.919,5.388-1.462,8.311a40.587,40.587,0,0,0-19.211-1.086",
    transform: "translate(-76.199 -60.275)",
    fill: "#ff6947"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M144.586,404.524s-1.838,1.712-2.422,1.671-1.128-.919,2.422-1.671",
    transform: "translate(-135.818 -387.63)",
    fill: "#534741"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M172.139,521.219a1.023,1.023,0,0,1,.041-1.318,4.113,4.113,0,0,1,1.555.039,1.022,1.022,0,0,1-.05,1.347,8.118,8.118,0,0,1-1.546-.068",
    transform: "translate(-164.738 -498.133)",
    fill: "#534741"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M200.245,526c0,.265-.065.48-.146.48s-.146-.215-.146-.48.065-.48.146-.48.146.215.146.48",
    transform: "translate(-191.602 -503.576)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M141.953,517.858a11.758,11.758,0,0,1,3.926,0,6.342,6.342,0,0,0-3.926,0",
    transform: "translate(-136.025 -495.91)",
    fill: "#534741"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M368.714,521.184a1.023,1.023,0,0,0,.087-1.316,4.116,4.116,0,0,0-1.552-.112,1.023,1.023,0,0,0-.081,1.346,8.134,8.134,0,0,0,1.545.083",
    transform: "translate(-351.629 -498.023)",
    fill: "#534741"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M402.12,527.9c0,.208-.037.376-.084.376s-.084-.168-.084-.376.037-.376.084-.376.084.168.084.376",
    transform: "translate(-385.166 -505.493)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M336.834,517.486a11.756,11.756,0,0,1,3.923.153,6.343,6.343,0,0,0-3.923-.153",
    transform: "translate(-322.767 -495.614)",
    fill: "#534741"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    transform: "translate(9.555 18.857)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M228.833,457.413s-.384-.6,1-1.671c1.086-.835.626-3.717-.042-4.218a3.158,3.158,0,0,1,.877,3.675c-.626,1.336-1.879,1.169-1.838,2.214",
    transform: "translate(-228.784 -451.524)",
    fill: "#fff"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M522.231,300.146a1.125,1.125,0,0,0-.643-1.348c-.82-.267-.871.288-1.081-.272,0,0,.016.726.549.782,0,0-.543-.289-.854.072,0,0,.471.471.271.71,0,0-.532.133-.565-.377,0,0-.355-.006.061,1s2.262-.564,2.262-.564",
    transform: "translate(-498.06 -286.059)",
    fill: "#534741"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M55.231,287.146a1.125,1.125,0,0,0-.643-1.348c-.82-.267-.871.288-1.081-.272,0,0,.016.726.549.782,0,0-.543-.289-.854.072,0,0,.471.471.271.71,0,0-.532.133-.565-.377,0,0-.355-.006.061,1s2.262-.564,2.262-.564",
    transform: "translate(-50.563 -273.602)",
    fill: "#534741"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M232.411,274.307a1.359,1.359,0,0,0-1.351-1.194c-1.038.092-.832.732-1.33.209,0,0,.361.8.979.61,0,0-.74-.064-.915.483,0,0,.747.3.637.661,0,0-.529.4-.807-.152,0,0-.4.161.539,1.081s2.248-1.7,2.248-1.7",
    transform: "translate(-219.954 -261.702)",
    fill: "#534741"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502",
    transform: "translate(9.604 31.303)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M229.953,749.524s1.838,2.213,5.22.459v1.671a28.74,28.74,0,0,0-5.22-1.086s.626-.167,0-1.044",
    transform: "translate(-229.953 -749.524)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(10.397 33.433)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M250.248,800.712c0,.1-.29.188-.647.188s-.647-.084-.647-.188.29-.188.647-.188.647.084.647.188",
    transform: "translate(-248.953 -800.524)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508",
    transform: "translate(11.274 31.553)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M270.872,755.67c0,.081-.206.146-.459.146s-.459-.065-.459-.146.206-.146.459-.146.459.065.459.146",
    transform: "translate(-269.953 -755.524)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1511",
    "data-name": "Group 1511",
    transform: "translate(3.445 24.699)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1509",
    "data-name": "Group 1509",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M82.958,591.451s2.088-.292,2.3.585-.877-.167-1.921,0-1.086-.543-.376-.585",
    transform: "translate(-82.479 -591.404)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514",
    transform: "translate(3.111 25.868)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1513",
    "data-name": "Group 1513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1512",
    "data-name": "Group 1512",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M74.958,619.451s2.088-.292,2.3.585-.877-.167-1.921,0-1.086-.543-.376-.585",
    transform: "translate(-74.479 -619.404)",
    fill: "#ff4023"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517",
    transform: "translate(19.14 22.885)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1516",
    "data-name": "Group 1516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1515",
    "data-name": "Group 1515",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M458.444,549.029s1.128-1.253,2.13-1.044,1.128.251,0,.794-2.8,1.462-2.13.251",
    transform: "translate(-458.291 -547.962)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520",
    transform: "translate(19.892 24.346)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M476.444,584.029s1.128-1.253,2.13-1.044,1.128.251,0,.794-2.8,1.462-2.13.251",
    transform: "translate(-476.291 -582.962)",
    fill: "#ff4023"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    "data-name": "Group 1523",
    transform: "translate(24.96 18.361)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    "data-name": "Group 1522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1521",
    "data-name": "Group 1521",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M599.749,439.854s-3.3-1.336-1.629,2.84a14.685,14.685,0,0,0,1.629-2.84",
    transform: "translate(-597.648 -439.651)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1526",
    "data-name": "Group 1526",
    transform: "translate(1.627 18.697)",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1525",
    "data-name": "Group 1525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1524",
    "data-name": "Group 1524",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M38.953,447.857s2.756-1.253,1.378,3.258c0,0-.084-2.8-1.378-3.258",
    transform: "translate(-38.953 -447.697)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1529",
    "data-name": "Group 1529",
    transform: "translate(3.321 5.94)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1528",
    "data-name": "Group 1528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1527",
    "data-name": "Group 1527",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M100.582,147.609a11.86,11.86,0,0,0,.412-2.984c-9.94-3.586-17.572-2.372-21.414-1.24a21.052,21.052,0,0,0,.023,3.364c7.953-2.114,16.868-.254,20.979.861",
    transform: "translate(-79.522 -142.236)",
    fill: "#fff"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/avatar4.e626595886a13b713a7ff8c823d2a688.svg";
export { ForwardRef as ReactComponent };